import { render, staticRenderFns } from "./EdgeGatewayEdit.vue?vue&type=template&id=f1f6e9d6&scoped=true"
import script from "./EdgeGatewayEdit.vue?vue&type=script&lang=js"
export * from "./EdgeGatewayEdit.vue?vue&type=script&lang=js"
import style0 from "./EdgeGatewayEdit.vue?vue&type=style&index=0&id=f1f6e9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f6e9d6",
  null
  
)

export default component.exports